import { render, staticRenderFns } from "./review-result.vue?vue&type=template&id=333bbebe&scoped=true"
import script from "./review-result.vue?vue&type=script&lang=js"
export * from "./review-result.vue?vue&type=script&lang=js"
import style0 from "./review-result.vue?vue&type=style&index=0&id=333bbebe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "333bbebe",
  null
  
)

export default component.exports